<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3 ik-card-login"  v-if="!blockMobile">
                    <h5 class="p-text-bold p-pt-4">Login</h5>
                    <div class="p-field p-mt-4">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="usuario.codigoEmpresa" type="text" placeholder="Código Empregador"/>                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="exibirErroCodigoEmpresa">Informe o código do empregador</small>  
                    </div>
                    <div class="p-field p-mt-4">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="usuario.cpfEmail" type="text" placeholder="CPF ou Email"/>                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="exibirErroEmail">Informe o cpf ou email</small>  
                    </div>
                    <div class="p-field">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />
                            <InputText v-model.trim="usuario.senha" type="password" placeholder="Senha" v-on:keyup.enter="login"/>                            
                        </span>          
                        <small id="senha-erro" class="p-invalid" v-if="exibirErroSenha">Informe a senha</small>              
                        <div class="p-grid p-d-flex p-jc-between p-mt-1">
                            <div class="p-col-6 p-text-left">
                                <a href="/validar" class="text-help">Primeiro Acesso?</a> 
                            </div>
                            <div class="p-col-6 p-text-right">
                                <a href="/esqueci-senha" class="text-help">Esqueceu a senha?</a> 
                            </div>                        
                        </div>                                      
                    </div>   
                    <div class="p-grid p-mt-3 p-mb-4">
                        <div class="p-col-12">
                            <Button label="Login" @click="login"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="exibirErro">{{ mensagemErro }}</Message>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;" v-else>
                    Baixe o app na Store para Registrar seu Ponto.
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import LoginService from '@/service/LoginService';
import { mapActions } from 'vuex';
import http from '@/plugins/axios/axios';
import { CHAVE_USUARIO, CHVAE_TOKEN } from '@/global';
import CacheCrypto from '@/plugins/cripto/CacheCrypto.js';

export default {
    loginService: null, 
    cacheCrypto: null,
    data() {
        return {
            blockMobile: false,
            exibirSpin: false,
            exibirErroEmail: false,
            exibirErroSenha: false,
            exibirErroCodigoEmpresa: false,
            mensagemErro: '',
            exibirErro: false,           
            usuario: {
                cpfEmail: '',
                senha: '',
                codigoEmpresa: '',
            }
        }
    },    
    methods: {
        ...mapActions('sessao', ['criarSessao', 'limparSessao']),
        /**
         * 
         */
        login() {
            this.exibirSpin = true;
            this.exibirErro = false;
            this.exibirErroEmail = false;
            this.exibirErroSenha = false;
            this.exibirErroCodigoEmpresa = false;
            if(this.usuario.cpfEmail == '') {
                this.exibirErroEmail = true;
            }
            if(this.usuario.senha == '') {
                this.exibirErroSenha = true;
            }
            if(this.usuario.codigoEmpresa == '') {
                this.exibirErroCodigoEmpresa = true;
            }            
            if(!this.exibirErroEmail && !this.exibirErroSenha && !this.exibirErroCodigoEmpresa) {            
                this.loginService.autenticar(this.usuario)
                    .then(resp => {
                        this.usuario = {};     
                        // Header do axios
                        http.defaults.headers.common['Authorization'] = 'Bearer '+resp.data.token.access; 
                        http.defaults.headers.common['X-IKPonto-Request'] = 'onapp'; 
                        this.cacheCrypto.add(CHAVE_USUARIO, JSON.stringify(resp.data))
                        this.cacheCrypto.add(CHVAE_TOKEN, JSON.stringify(resp.data.token))                                      
                        this.criarSessao(resp.data);                         
                        this.exibirSpin = false;                                             
                        this.$router.push({ path: '/' });                        
                    })
                    .catch(erro => {  
                        console.log(erro)     
                        this.exibirSpin = false;                 
                        this.exibirErro = true;
                        if(erro.response.status == 400) {
                            this.mensagemErro = erro.response.data.mensagem;
                        } else {
                            this.mensagemErro = erro.response.data.mensagem;
                        }
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        /**
         * 
         */
        validarToken() {       
            if(this.$route.query.exp && this.$route.query.exp === 'sessao_expirada') {
                this.exibirErro = true;
                this.mensagemErro = 'Sessão Expirada';
            }        
            let token = JSON.parse(this.cacheCrypto.get(CHVAE_TOKEN));               
            if(!token) {                                          
                return   
            }             
            let dadosUsuario = JSON.parse(this.cacheCrypto.get(CHAVE_USUARIO));                         
            if(!dadosUsuario) {
                return;
            }
            this.criarSessao(dadosUsuario); 
            http.defaults.headers.common['Authorization'] = 'Bearer '+token.access; 
            http.defaults.headers.common['X-IKPonto-Request'] = 'onapp';      
            this.$router.push({ path: '/' });
        },
        /**
         * 
         */
        isAgentWebMobile() {
            if (navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i)
            ) {
                //this.blockMobile = true;
                return true;
            } else {
                //this.blockMobile = false;
                return false;
            }
        }                  
    },
    created() {
        sessionStorage.setItem('AGENT_WEB_MOBILE', JSON.stringify({ mobile: this.isAgentWebMobile() }));
        //if(!this.isAgentWebMobile()) {
            this.cacheCrypto = new CacheCrypto();
            this.loginService = new LoginService();        
            this.validarToken();
        //}
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>